import React from 'react';
import { Grid, InputLabel, OutlinedInput, Select, MenuItem, Checkbox, FormControlLabel, FormGroup, Typography, Divider } from '@mui/material';
import { IItemPurchaseAddEditRequest } from '../../../../model/scp/purchase/request/purchase-item-add-edit-request';
import { ITableResponse } from '../../../../model/scp/purchase/response/tables-response';
import BrazilianNumberInput from '../../../../components/brazilian-number-input';

export interface IPurchaseItemFormProps {
    itemPurchase: IItemPurchaseAddEditRequest;
    materialService: ITableResponse[];
    benefitType: ITableResponse[];
    judgementCriteria: ITableResponse[];
    categoryItemPurchase: ITableResponse[];
    purchaseItemSituation: ITableResponse[];
    purchaseId?: string | undefined;
    handleOnChange: (e: any) => void;
    handleCurrencyChange: (value: string | undefined, name: string) => void;
}

export default function PurchaseItemForm({ props }: { props: IPurchaseItemFormProps }) {
    const {
        itemPurchase,
        materialService,
        benefitType,
        judgementCriteria,
        categoryItemPurchase,
        purchaseItemSituation,
        purchaseId,
        handleOnChange,
        handleCurrencyChange
    } = props;

    return (
        <Grid container spacing={3}>
            {purchaseId != null && itemPurchase.number !== undefined && (
                <>
                    {/* Seção: Situação */}
                    <Grid item xs={12}>
                        <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
                            Situação
                        </Typography>
                        <Divider sx={{ mb: 2 }} />
                    </Grid>

                    <Grid item xs={12}>
                        <InputLabel>Situação</InputLabel>
                        <Select
                            autoComplete='off'
                            onChange={handleOnChange}
                            onBlur={handleOnChange}
                            fullWidth
                            error={purchaseId != null && itemPurchase?.situationPurchaseItemId === undefined && itemPurchase.number !== undefined ? true : false}
                            value={itemPurchase.situationPurchaseItemId ? itemPurchase.situationPurchaseItemId : ''}
                            name='select-situation-purchase-item'
                        >
                            <MenuItem value={undefined}>
                                <em>Selecionar</em>
                            </MenuItem>
                            {purchaseItemSituation.map((element) => (
                                <MenuItem value={element.id} key={element.id}>{element.id} - {element.name}</MenuItem>
                            ))}
                        </Select>
                    </Grid>
                </>
            )}

            {/* Seção: Classificação do Item */}
            <Grid item xs={12}>
                <Typography variant="h6" sx={{ mb: 2, mt: purchaseId != null && itemPurchase.number !== undefined ? 2 : 0, color: 'primary.main', fontWeight: 600 }}>
                    Classificação do Item
                </Typography>
                <Divider sx={{ mb: 2 }} />
            </Grid>

            <Grid item lg={6} sm={12} xl={6}>
                <InputLabel>Tipo</InputLabel>
                <Select
                    autoComplete='off'
                    onChange={handleOnChange}
                    onBlur={handleOnChange}
                    fullWidth
                    error={itemPurchase?.typeItemId === undefined ? true : false}
                    value={itemPurchase.typeItemId ? itemPurchase.typeItemId : ''}
                    name='select-type-item'
                >
                    <MenuItem value={undefined}>
                        <em>Selecionar</em>
                    </MenuItem>
                    {materialService.map((element) => (
                        <MenuItem value={element.id} key={element.id}>{element.id} - {element.name}</MenuItem>
                    ))}
                </Select>
            </Grid>

            <Grid item lg={6} sm={12} xl={6}>
                <InputLabel>Categoria</InputLabel>
                <Select
                    autoComplete='off'
                    onChange={handleOnChange}
                    onBlur={handleOnChange}
                    fullWidth
                    error={itemPurchase?.categoryItemId === undefined ? true : false}
                    value={itemPurchase.categoryItemId ? itemPurchase.categoryItemId : ''}
                    name='select-category-item'
                >
                    <MenuItem value={undefined}>
                        <em>Selecionar</em>
                    </MenuItem>
                    {categoryItemPurchase.map((element) => (
                        <MenuItem value={element.id} key={element.id}>{element.id} - {element.name}</MenuItem>
                    ))}
                </Select>
            </Grid>

            <Grid item lg={6} sm={12} xl={6}>
                <InputLabel>Tipo Beneficio</InputLabel>
                <Select
                    autoComplete='off'
                    onChange={handleOnChange}
                    onBlur={handleOnChange}
                    fullWidth
                    error={itemPurchase?.typeBenefitId === undefined ? true : false}
                    value={itemPurchase.typeBenefitId ? itemPurchase.typeBenefitId : ''}
                    name='select-type-benefit'
                >
                    <MenuItem value={undefined}>
                        <em>Selecionar</em>
                    </MenuItem>
                    {benefitType.map((element) => (
                        <MenuItem value={element.id} key={element.id}>{element.id} - {element.name}</MenuItem>
                    ))}
                </Select>
            </Grid>

            <Grid item lg={6} sm={12} xl={6}>
                <InputLabel>Critério de Julgamento</InputLabel>
                <Select
                    autoComplete='off'
                    onChange={handleOnChange}
                    onBlur={handleOnChange}
                    fullWidth
                    error={itemPurchase?.criterionJudgmentId === undefined ? true : false}
                    value={itemPurchase.criterionJudgmentId ? itemPurchase.criterionJudgmentId : ''}
                    name='select-criterion-judgment'
                >
                    <MenuItem value={undefined}>
                        <em>Selecionar</em>
                    </MenuItem>
                    {judgementCriteria.map((element) => (
                        <MenuItem value={element.id} key={element.id}>{element.id} - {element.name}</MenuItem>
                    ))}
                </Select>
            </Grid>

            {/* Seção: Valores e Medidas */}
            <Grid item xs={12}>
                <Typography variant="h6" sx={{ mb: 2, mt: 2, color: 'primary.main', fontWeight: 600 }}>
                    Valores e Medidas
                </Typography>
                <Divider sx={{ mb: 2 }} />
            </Grid>

            <Grid item lg={3} sm={6} xl={3}>
                <InputLabel>Unidade de Medida</InputLabel>
                <OutlinedInput
                    autoComplete='off'
                    onChange={handleOnChange}
                    onBlur={handleOnChange}
                    error={itemPurchase?.unitMeasure === undefined || itemPurchase.unitMeasure.length === 0 ? true : false}
                    value={itemPurchase?.unitMeasure || ''}
                    name='input-unit-measure'
                    fullWidth
                />
            </Grid>

            <Grid item lg={3} sm={6} xl={3}>
                <InputLabel>Valor Unitário Estimado</InputLabel>
                <BrazilianNumberInput
                    value={itemPurchase?.unitValueEstimated}
                    onChange={(value) => handleCurrencyChange(value.toString(), 'input-unit-value-estimated')}
                    decimals={4}
                    prefix="R$"
                    placeholder="0,0000"
                    error={itemPurchase?.unitValueEstimated === undefined || itemPurchase?.unitValueEstimated === 0}
                    fullWidth
                />
            </Grid>

            <Grid item lg={3} sm={6} xl={3}>
                <InputLabel>Quantidade</InputLabel>
                <BrazilianNumberInput
                    value={itemPurchase?.quantity}
                    onChange={(value) => handleCurrencyChange(value.toString(), 'input-quantity')}
                    decimals={4}
                    placeholder="0,0000"
                    error={itemPurchase?.quantity === undefined || itemPurchase?.quantity === 0}
                    fullWidth
                />
            </Grid>

            <Grid item lg={3} sm={6} xl={3}>
                <InputLabel>Valor Total</InputLabel>
                <BrazilianNumberInput
                    value={itemPurchase?.amount}
                    onChange={(value) => handleCurrencyChange(value.toString(), 'input-amount')}
                    decimals={4}
                    prefix="R$"
                    placeholder="0,0000"
                    disabled={true}
                    error={itemPurchase?.amount === undefined || itemPurchase?.amount === 0}
                    fullWidth
                />
            </Grid>

            {/* Seção: Descrição */}
            <Grid item xs={12}>
                <Typography variant="h6" sx={{ mb: 2, mt: 2, color: 'primary.main', fontWeight: 600 }}>
                    Descrição
                </Typography>
                <Divider sx={{ mb: 2 }} />
            </Grid>

            <Grid item xs={12}>
                <InputLabel>Descrição</InputLabel>
                <OutlinedInput
                    autoComplete='off'
                    multiline
                    onChange={handleOnChange}
                    onBlur={handleOnChange}
                    rows={7}
                    error={itemPurchase?.description === undefined || itemPurchase?.description.length === 0 ? true : false}
                    value={itemPurchase?.description || ''}
                    name='input-description'
                    fullWidth
                />
            </Grid>

            {/* Seção: Informações Complementares */}
            <Grid item xs={12}>
                <Typography variant="h6" sx={{ mb: 2, mt: 2, color: 'primary.main', fontWeight: 600 }}>
                    Informações Complementares
                </Typography>
                <Divider sx={{ mb: 2 }} />
            </Grid>

            <Grid item lg={6} sm={12} xl={6}>
                <InputLabel>Patrimonio</InputLabel>
                <OutlinedInput
                    autoComplete='off'
                    onChange={handleOnChange}
                    onBlur={handleOnChange}
                    value={itemPurchase?.patrimony || ''}
                    name='input-patrimony'
                    fullWidth
                />
            </Grid>

            <Grid item lg={6} sm={12} xl={6}>
                <InputLabel>Código Registro Imobiliário</InputLabel>
                <OutlinedInput
                    autoComplete='off'
                    onChange={handleOnChange}
                    onBlur={handleOnChange}
                    error={itemPurchase.categoryItemId === 1 && (itemPurchase?.realEstateRegistryCode === undefined || itemPurchase?.realEstateRegistryCode.length === 0) ? true : false}
                    value={itemPurchase?.realEstateRegistryCode || ''}
                    name='input-real-estate-registry-code'
                    fullWidth
                />
            </Grid>

            {/* Seção: Opções Adicionais */}
            <Grid item xs={12}>
                <Typography variant="h6" sx={{ mb: 2, mt: 2, color: 'primary.main', fontWeight: 600 }}>
                    Opções Adicionais
                </Typography>
                <Divider sx={{ mb: 2 }} />
            </Grid>

            <Grid item xs={12}>
                <FormGroup>
                    <FormControlLabel
                        labelPlacement="start"
                        control={
                            <Checkbox
                                name="check-basic-produtive-incentive"
                                onChange={handleOnChange}
                                onBlur={handleOnChange}
                                checked={itemPurchase?.basicProductiveIncentive || false}
                            />
                        }
                        label="Incentivo Produtivo Básico"
                    />
                    <FormControlLabel
                        labelPlacement="start"
                        control={
                            <Checkbox
                                onChange={handleOnChange}
                                onBlur={handleOnChange}
                                name="check-budget-confidential"
                                checked={itemPurchase?.budgetConfidential || false}
                            />
                        }
                        label="Orçamento Sigiloso"
                    />
                </FormGroup>
            </Grid>
        </Grid>
    );
}
